import { c as _c } from "react/compiler-runtime";
import Tooltip from '@precis-digital/kurama/Tooltip';
import { type ReactElement } from 'react';
import type { ChartCardTFunction } from '../../../types';
import { headerIconSize } from '../constants';
import { ActiveFilterIcon } from '../styled';
interface TableHeadCellFilteredProps {
  t: ChartCardTFunction;
}
const TableHeadCellFiltered = t0 => {
  const $ = _c(5);
  const {
    t
  } = t0;
  let t1;
  if ($[0] !== t) {
    t1 = t("filteredData");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ActiveFilterIcon {...headerIconSize} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Tooltip key="sort-button-tooltip" kind="singleline" title={t1}>{t2}</Tooltip>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default TableHeadCellFiltered;